import { parentModeConstants } from "../../../constants/parentModeConstants"

export function setIsParentMode(newState) {
    return {
        type: parentModeConstants.SET_IS_PARENT_MODE,
        newState,
    }
}

export function setParentModeFamilyId(familyId) {
    return {
        type: parentModeConstants.SET_PARENT_MODE_FAMILY_ID,
        familyId,
    }
}
